import { FC } from 'react';
import { useIntl } from 'react-intl';

import type { PartnerTemplatePartner } from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';
import { Badge } from '@/shared/ui';

import { getPartnerTemplateName } from '../../lib';

type Props = {
  partner: PartnerTemplatePartner;
  className?: string;
};

export const PartnerTemplateBadge: FC<Props> = ({ partner, className }) => {
  const { formatMessage } = useIntl();

  return (
    <Badge size="small" tone="violet" className={className}>
      {getPartnerTemplateName(formatMessage, partner)}
    </Badge>
  );
};
